<template>
  <section>
    <div id="app">
      <router-view />
      <MainPage :data="content[locality]" :locality="locality" />
    </div>
  </section>
</template>

<script>
import MainPage from "./pages/index.vue";
import Content from "./data/content";

export default {
  name: "App",
  components: { MainPage },
  data() {
    return {
      locality: process.env.VUE_APP_LOCALITY,
      content: Content,
    };
  },
};
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;


#app {
  --color-orange-1: rgb(255, 128, 0);
  --color-white-1: rgb(255, 255, 255);
  --color-mozzarella-4: rgb(234, 231, 228);
  --color-mozzarella-3: rgb(250, 250, 250);
  --color-mozzarella-2: rgb(245, 243, 241);
  --color-mozzarella-1: rgb(239, 237, 234);
  --color-charcoal-1: rgb(36, 46, 48);
  --color-aubergine-1: rgb(91, 61, 91);
  --color-tumeric-1: rgb(246, 194, 67);
  --color-berry-1: rgb(242, 166, 176);
  --color-cupcake-1: rgb(193, 218, 222);
  --color-tomato-1: rgb(247, 94, 40);
  --color-grey-1: rgb(229, 229, 229);
  --color-blue-1: rgb(21, 116, 245);

  padding: 0;
  margin: 0;
  width: 100%;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: 'fontello';
  src: url('https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/fontello/fontello.eot?74446509');
  src: url('https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/fontello/fontello.eot?74446509#iefix') format('embedded-opentype'),
    url('https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/fontello/fontello.woff?74446509') format('woff'),
    url('https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/fontello/fontello.ttf?74446509') format('truetype'),
    url('https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/fontello/fontello.svg#fontello?74446509') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "jet-regular";
  font-weight: normal;
  font-style: normal;
  src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Regular.eot"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Regular.eot?#iefix") format("embedded-opentype"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Regular.woff2") format("woff2"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Regular.woff") format("woff")
}

@font-face {
  font-family: "jet-italic";
  font-weight: normal;
  font-style: normal;
  src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Italic.eot"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Italic.eot?#iefix") format("embedded-opentype"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Italic.woff2") format("woff2"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Italic.woff") format("woff")
}

@font-face {
  font-family: "jet-bold";
  font-weight: normal;
  font-style: normal;
  src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Bold.eot"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Bold.eot?#iefix") format("embedded-opentype"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Bold.woff2") format("woff2"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Bold.woff") format("woff")
}

@font-face {
  font-family: "jet-bold-Italic";
  font-weight: normal;
  font-style: normal;
  src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-BoldItalic.eot"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-BoldItalic.eot?#iefix") format("embedded-opentype"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-BoldItalic.woff2") format("woff2"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-BoldItalic.woff") format("woff")
}

@font-face {
  font-family: "jet-extrabold";
  font-weight: normal;
  font-style: normal;
  src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBold.eot"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBold.eot?#iefix") format("embedded-opentype"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-ExtraBold.woff2") format("woff2"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-ExtraBold.woff") format("woff")
}

@font-face {
  font-family: "jet-extrabold-Italic";
  font-weight: normal;
  font-style: normal;
  src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBoldItalic.eot"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBoldItalic.eot?#iefix") format("embedded-opentype"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-ExtraBoldItalic.woff2") format("woff2"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-ExtraBoldItalic.woff") format("woff")
}

@font-face {
  font-family: "jet-extrablack";
  font-weight: normal;
  font-style: normal;
  src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSans-ExtraBlack.eot"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSans-ExtraBlack.eot?#iefix") format("embedded-opentype"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSans-ExtraBlack.woff2") format("woff2"),
    url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSans-ExtraBlack.woff") format("woff")
}


* {
  text-rendering: optimizeSpeed;
  font-variant-ligatures: no-common-ligature;
  font-variant-ligatures: none;
}

body, html {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  overflow-x: hidden !important;
  overflow-y: scroll;
  position: relative;
  font-family: 'jet-regular', 'Open Sans', 'Avant Garde', 'Century Gothic', Helvetica, Arial, sans-serif;
  color: #242f30;
  -webkit-font-smoothing: antialiased;
}



h1 {
  max-width: 600px;
  padding: 0 0 16px;
  font-family: 'jet-extrabold', 'Open Sans', Helvetica, sans-serif;
  font-size: 72px;
  line-height: 80px;
  color: #fff;
  text-align: left;
}
h1.smaller {
  font-size: 72px;
  line-height: 76px;
}

h2 {
  margin: 0;
  font-family: 'jet-bold', 'Open Sans', Helvetica, sans-serif;
  font-size: 44px;
  line-height: 48px;
  color: #242f30;
  text-align: center;
}

h3 {
  font-family: 'jet-bold', 'Open Sans', Helvetica, sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #242f30;
}

h4 {
  margin: 30px 0;
  font-family: 'jet-bold', 'Open Sans', Helvetica, sans-serif;
  font-size: 22px;
  line-height: 22px;
  text-align: left;
  color: #fff;
}

h5 {
  margin-bottom: 0;
  font-family: 'jet-bold', 'Open Sans', Helvetica, sans-serif;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  color: #242f30;
}

button {
  font-family: "jet-bold", sans-serif;
  min-width: 200px;
  padding: 15px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  @media (max-width: $tablet) {
    font-size: 12px;
    padding: 10px;
    min-width: 140px;
  }
}
.cc-banner__container {
  background: white !important;
}
.cc-banner__text {
  color: #242e30 !important;
  font-size: 16px !important;
  font-family: "jet-regular", sans-serif !important;
}
.cc-banner__wrapper {
  max-width: 80% !important;
}
.cc-banner__btn-ok {
  border-radius: 30px !important;
  background: #1574f5 !important;
  padding: 15px 20px !important;
  color: white !important;
  &:focus {
    background: #1574f5 !important;
    color: white !important;
  }
  &:hover {
    transform: scale(1.05) !important;
  }
}

.jet-vid {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}
.jet-vid video, .jet-vid iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 30px;
}
.video-play {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  cursor: pointer;
}
</style>
